import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { ReactComponent as AlertIcon } from "src/Themes/assets/NewIcons/Status-Error.svg";
import { ReactComponent as InfoIcon } from "src/Themes/assets/info.svg";
import { ReactComponent as WarnIcon } from "src/Themes/assets/CertIconAlert.svg";
import st from "./AlertMessage.module.scss";

type AlertMessageTypes = "error" | "info" | "warn";

interface IAlertMessageProps extends React.HTMLAttributes<HTMLDivElement> {
	variant?: AlertMessageTypes;
	withIcon?: boolean;
};

const AlertMessage: FC<IAlertMessageProps> = ( { variant = "error", withIcon = true, className, children, ...otherProps } ) => (
	<div className={classNames( st.alert, className, st[variant])} {...otherProps}>
		{ withIcon && renderIcon(variant) }
		<p className='body-large'>{ children }</p>
	</div>
);

const renderIcon = ( variant: AlertMessageTypes ): ReactNode => {
	switch( variant ) {
		case "error": return	<AlertIcon />;
		case "info":  return	<InfoIcon  />;
		case "warn":  return	<WarnIcon />;
		default: return null;
	}
};

export default AlertMessage;
